<template>
  <BField
    class="ls-checkboxes"
    :label="label"
    :type="{ 'is-error': getValidation.invalid }"
    :message="getValidation.message"
  >
    <section :class="{ 'ls-checkboxes--section': columns }">
      <div
        v-for="option in options"
        :key="option.label"
        class="field"
        :class="{
          'has-second-line': option.secondLine,
        }"
      >
        <BCheckbox
          v-model="localValue"
          v-validate="validation"
          :name="name"
          :native-value="option.value"
          :disabled="option.disabled || disabled"
          test-id="ls-checkbox"
          type="is-primary-invert"
        >
          <span :class="{ label: option.boldLabel }">{{ option.label }}</span>
          <span v-if="!!option.secondLine">{{ option.secondLine }}</span>
        </BCheckbox>
      </div>
    </section>
  </BField>
</template>

<script>
import { lsPropTypeHelpers, lsTrackingService, lsValidationService } from 'ls-vue-common';
import VueTypes from 'vue-types';
import _ from 'lodash';

export default {
  name: 'LsCheckboxes',
  inject: ['$validator'],
  props: {
    // allow a single boolean value in the case of a single checkbox,
    // use array for anything over single option
    value: VueTypes.oneOfType([Array, Boolean]).isRequired,
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
    name: VueTypes.string.isRequired,
    options: VueTypes.arrayOf(
      VueTypes.shape({
        label: VueTypes.string.isRequired,
        value: VueTypes.any.isRequired,
        disabled: VueTypes.bool,
        boldLabel: VueTypes.bool,
        secondLine: VueTypes.string,
      })
    ).isRequired,
    label: VueTypes.string,
    disabled: VueTypes.bool.def(false),
    validation: VueTypes.object.def(_.constant(null)),
    columns: VueTypes.bool.def(false),
  },

  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        lsTrackingService.track({
          event: 'click',
          target: this.trackId,
          data: { value },
        });
        this.$emit('input', value);
      },
    },
    getValidation() {
      return lsValidationService.getValidation.call(this, 'checkboxes');
    },
  },
};
</script>

<style lang="scss">
@media (min-width: $desktop) {
  .ls-checkboxes {
    .label {
      font-weight: 700;
    }
  }
  .ls-checkboxes--section {
    display: flex;
    flex-wrap: wrap;
    div {
      flex: 50%;
      min-width: 50%;
    }
  }
}

.b-checkbox {
  .control-label {
    padding-left: $size-6 !important;
  }

  .check {
    border: 1px solid $gray-tertiary !important;
    height: $size-2 !important;
    width: $size-2 !important;
    &:before {
      height: $size-7 !important;
      width: $size-7 !important;
    }
  }
}

.has-second-line {
  .b-checkbox {
    align-items: flex-start;
  }
}
</style>
